import React, { memo } from "react";
import useNotificationsPage from "./index.hooks";
import { AppPaper, SendNotificationDialog } from "components";
import { Typography } from "@material-ui/core";
import { DataGrid, GridSortDirection } from "@material-ui/data-grid";

const paginationLimits = [5, 10, 25, 50, 100];

type NotificationsPageProps = {};

const NotificationsPage = ({}: NotificationsPageProps) => {
  const {
    styles,
    isMobile,
    datagridComponents,
    gridData,
    limit,
    page,
    handleLimitChange,
    handlePageChange,
    notificationsCount,
    loading,
  } = useNotificationsPage();

  return (
    <AppPaper>
      <SendNotificationDialog />
      <Typography variant="h4" color="primary" className={styles.inline}>
        Notifiche
      </Typography>
      <DataGrid
        columnBuffer={2}
        disableSelectionOnClick
        density={isMobile ? "compact" : "standard"}
        components={datagridComponents}
        columns={gridData.cols}
        rows={gridData.rows}
        sortModel={[
          {
            field: "sentDate",
            sort: "desc" as GridSortDirection,
          },
          {
            field: "views",
            sort: "asc" as GridSortDirection,
          },
        ]}
        rowHeight={isMobile ? 200 : 80}
        headerHeight={isMobile ? 0 : 50}
        pagination
        page={page}
        loading={loading}
        pageSize={limit}
        rowCount={notificationsCount}
        rowsPerPageOptions={paginationLimits}
        onPageSizeChange={handleLimitChange}
        onPageChange={handlePageChange}
        paginationMode={"server"}
        autoHeight
      />
    </AppPaper>
  );
};

export default memo(NotificationsPage);
